import { render, staticRenderFns } from "./SolicitudNuevaContrasenia.vue?vue&type=template&id=bcd202f8"
import script from "./SolicitudNuevaContrasenia.vue?vue&type=script&lang=js"
export * from "./SolicitudNuevaContrasenia.vue?vue&type=script&lang=js"
import style0 from "./SolicitudNuevaContrasenia.vue?vue&type=style&index=0&id=bcd202f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports